var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9316 0H4.06841C1.82149 0 0 1.82149 0 4.06841V19.9316C0 22.1785 1.82149 24 4.06841 24H19.9316C22.1785 24 24 22.1785 24 19.9316V4.06841C24 1.82149 22.1785 0 19.9316 0Z",
    fill: "url(#paint0_linear_20_296)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.88235 4C7.74 4 6 5.74604 6 7.89583V21H6.70588V13.2083H14.1176C16.26 13.2083 18 11.4623 18 9.3125V4H9.88235ZM17.2941 9.3125C17.2941 11.0692 15.8682 12.5 14.1176 12.5H6.70588V7.89583C6.70588 6.13917 8.13176 4.70833 9.88235 4.70833H17.2941V9.3125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_296",
    x1: 0,
    y1: 12,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06A099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#189CD9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 17,
    fill: "white",
    transform: "translate(6 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainings);
export default __webpack_public_path__ + "static/media/trainings.fa4e696d3c3c8366928048950b1ea143.svg";
export { ForwardRef as ReactComponent };